<template>
<div>
    <div class="form-container ou-donation-form">
        <div class="holder">
            <PaymentForm class="form-horizontal">
                <FormSection title="Donation">
                    <div>
                        <AmountSelector :includeOther="false"/>                 
                        <ErrorLabel field="amount" />
                    </div>
                    <div class="frequency">
                      <PaymentOptions addMonthly onlyMonthly monthesSelector/>
                    </div>
                </FormSection>
                <FormSection title="Personal Details">
                    <FormRow inline>      
                        <FormCol field="title" :flex="1" />
                        <FormCol field="firstName" :flex="2" />
                        <FormCol field="lastName" :flex="2" />
                    </FormRow>
                    <FormRow inline>
                        <FormCol field="email" />
                        <FormCol field="phone" />
                    </FormRow>
                    <FormRow inline>
                <Consent privacy="https://ncsy.org/privacy-policy/"/>
                    </FormRow>       
                </FormSection>
                <FormSection title="Billing Information" >
                    <DonorAddress />
                </FormSection>
                <FormSection title="Payment Information" last>
                    <FormRow inline>
                    <FormCol field="card" :showLabel="false"/>
                    </FormRow>
                </FormSection>
                <PaymentButton />
            </PaymentForm>
        </div>
    </div>
</div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import { usePaymentForm } from '~/shared/use-payment-form'

export default defineComponent({
  props: {
    subCampaign: String,
  },
  setup(props) {
    const { form, submit } = usePaymentForm()

    return {
      form,
      submit,
    }
  },
})
</script>
<style scoped lang="scss">
h2.payment-heading {
  display: flex;
  justify-content: space-between;
}
.card-img {
  display: flex;
  img {
    height: 23px;
  }
}
</style>

